import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import lang from '~/lang/nl-NL';
export default {
  data: function data() {
    return {
      shippingCost: 0,
      productsBeingEdited: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    items: 'cart/items'
  })), {}, {
    combinedPrice: function combinedPrice() {
      return this.items.reduce(function (acc, curr) {
        return acc + curr.amount * curr.quantity;
      }, 0);
    },
    totalPrice: function totalPrice() {
      return this.combinedPrice + this.shippingCost + (this.hasPhysical ? this.deliveryPrice : 0);
    },
    hasPhysical: function hasPhysical() {
      return this.items.some(function (_ref) {
        var product = _ref.product;
        return product.fysiek;
      });
    },
    hasDigital: function hasDigital() {
      return this.items.some(function (_ref2) {
        var product = _ref2.product;
        return !product.fysiek;
      });
    },
    deliveryPrice: function deliveryPrice() {
      var _this$$store$state$se;

      return this.hasPhysical ? parseFloat(((_this$$store$state$se = this.$store.state.settings.find(function (s) {
        return s.key === 'verzendkosten';
      })) === null || _this$$store$state$se === void 0 ? void 0 : _this$$store$state$se.value) || 0) : 0;
    },
    taxes: function taxes() {
      return this.deliveryPrice * 21 / 121;
    }
  }),
  methods: {
    removeFromCart: function removeFromCart(cartItem) {
      this.$store.commit('cart/remove', cartItem);
    },
    changeQuantity: function changeQuantity(quantity, id) {
      if (!(quantity > 0)) {
        return;
      }

      this.$store.commit('cart/setQuantity', {
        id: id,
        quantity: quantity
      });
    },
    toggleProductEdit: function toggleProductEdit(id) {
      var index = this.productsBeingEdited.findIndex(function (p) {
        return p === id;
      });

      if (index !== -1) {
        this.productsBeingEdited.splice(index, 1);
      } else {
        this.productsBeingEdited.push(id);
      }
    },
    changeValue: function changeValue(amount, id) {
      if (this.isNumeric(amount)) {
        this.$store.commit('cart/setAmount', {
          id: id,
          amount: amount
        });
      }
    },
    isNumeric: function isNumeric(value) {
      value = parseFloat(value);
      return typeof value === 'number' && !isNaN(value);
    }
  }
};